jQuery(document).ready(function($) {

    const $forms = $('.js-standard-glasses-calculator');
    const $standardGlasses = $('.js-standard-glasses');

    $forms.each( function (key, el) {

        const $form = $(el);
        const $inputs = $form.find('input[type=number]');
        const $result = $form.find('.js-result');
        const $input = $form.find('.js-result-input');

        $inputs.on('keyup', function () {
            updateResult();
        });

        $inputs.on('change', function () {
            updateResult();
        });

        function updateResult() {
            let total = 0;
            $inputs.each( function (key, el) {
                let val = parseFloat($(el).val());
                if ( isNaN(val) ) val = 0;
                const number = parseFloat($(el).data('number'));
                total += val*number;
            });
            $result.html(total);
            if ($standardGlasses.length) $standardGlasses.val(total);
            if ($input.length) $input.val(total);
        }

    });

});